import { Container, ContainerProps } from './styles';

export type GridProps = React.HTMLAttributes<HTMLElement> & ContainerProps;

export default function Grid({ className, ...rest }: GridProps) {
  return <Container display="grid" className={className} {...rest} />;
}
